<template>
  <v-menu v-model="menu" open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="organizationSelected"
        :clearable="!unclearable"
        :items="organizationsSelected"
        :loading="organizationsLoading"
        :search-input.sync="organizationsSearch"
        item-text="name"
        item-value="code"
        :label="
          noLabel
            ? ''
            : $t('Organization.title')
        "
        return-object
        v-bind="attrs"
        v-on="on"
        :error-messages="errorMessages"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="tree"
          :items="organizations"
          :search="organizationsSearch"
          :filter="organizationsFilter"
          :active.sync="organizationsSelected"
          item-key="id"
          item-children="organizations"
          open-all
          hoverable
          activatable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import Organizations from "@/api/organizations";

export default {
  name: "SearcherOrganization",

  props: {
    value: Object,
    label: String,
    noLabel: Boolean,
    unclearable: Boolean,
    errorMessages: Array,
  },

  computed: {
    organizationsFilter() {
      return (item, search, textKey) =>
        this.organizationSelected && search == this.organizationSelected.name
          ? true
          : item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getOrganizationsFromAPI();
  },

  data: () => ({
    menu: false,
    tree: [],
    organizations: [],
    organizationsLoading: false,
    organizationsSearch: "",
    organizationsSelected: [],
    organizationSelected: null,
  }),

  methods: {
    getOrganizationsFromAPI() {
      this.organizationsLoading = true;
      Organizations.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.organizations = response.data.organizations;
            }
            this.organizationsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.organizationsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.organizationsSelected = this.value ? [this.value] : [];
      },
    },
    organizationsSelected: {
      immediate: true, //初始赋值也调用
      handler() {
        this.organizationSelected =
          this.organizationsSelected && this.organizationsSelected[0]
            ? this.organizationsSelected[0]
            : null;
      },
    },
    organizationSelected: {
      handler() {
        this.organizationsSelected = this.organizationSelected
          ? [this.organizationSelected]
          : [];
        this.$emit("input", this.organizationSelected);
      },
    },
    organizationsSearch: {
      handler() {
        if (!this.unclearable && !this.organizationsSearch)
          this.organizationsSelected = [];
      },
    },
  },
};
</script>
